// Module
var code = "<table ref=\"weekShiftsTable\" class=\"table table-light\">\n    <thead>\n        <tr ref=\"tHeadRow\">\n        </tr>\n    </thead>\n    <tbody ref=\"tBody\">\n    </tbody>\n</table>";
// Exports
module.exports = code;